import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { AuthContext } from '../../context/AuthContext'
import { Authorities } from '../../models/authorities'

const authorityTooltip = (authorized, title) =>
  function (element) {
    if (!authorized) {
      return (
        <div data-toggle="tooltip" title={title}>
          {element}
        </div>
      )
    }
    return element
  }

export default (disabledProperty = 'disabled') =>
  WrappedComponent => {
    const AuthorityWrapper = ({ authority, unauthorizedTitle, ...props }) => {
      const { hasAuthority } = useContext(AuthContext)

      return authorityTooltip(
        hasAuthority(authority),
        unauthorizedTitle,
      )(
        <WrappedComponent
          {...props}
          {...(!hasAuthority(authority)
            ? {
                [disabledProperty]: true,
              }
            : null)}
        />,
      )
    }
    AuthorityWrapper.propTypes = {
      ...WrappedComponent.propTypes,
      authority: PropTypes.oneOf(Object.values(Authorities)).isRequired,
      unauthorizedTitle: PropTypes.string.isRequired,
    }
    return AuthorityWrapper
  }
